export default __webpack_public_path__ + "home.laptop.normal.8f43e0974561170fb44e3669ed18b4c5.png";